import { fromJS, Record } from 'immutable';
import { Base } from './base';

class Schedule extends Base(Record({
    id: null,
    owner_id: null,
    owner_type: 'posts',
    frequency: 'weekly',
    week: null,
    days: fromJS([]),
    hours: fromJS([]),
    start_date: null,
    end_date: null
  })) {
    $create(id) {
      if (this.id && this.state.entities.get('schedules').get(this.id).isSuperset(this)) {
        return Promise.resolve('No op');
      }

      return this.api.post({
          resource: 'schedules'
        }, this.api.payload('schedules', id ? this.set('owner_id', id) : this));
    }

    $delete() {
      return this.api.delete({
        id: this.id,
        resource: 'schedules'
      });
    }

    $get(id) {
      if (this.owner_id) id = this.owner_id;

      if (!id) return Promise.resolve(null);

      return this.api.get({
        resource: 'schedules?filter[owner_id]=' + id
      })
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'schedules')));
    }

    $put() {
      return this.api.patch({
        id: this.id,
        resource: 'schedules'
      }, this.api.payload('schedules', this));
    }
  }

export default Schedule;



// WEBPACK FOOTER //
// ./src/records/schedule.js